<template>
  <div class="bg-black rounded-t-none rounded-lg pb-2 max-h-screen overflow-scroll">
    <div class="text-base">
      <div v-if="!isInEditMode">
        <button v-if="!isInNewMode" class="p-3 w-full focus:outline-none cursor-pointer" @click="isInNewMode = true">
          + Nouveau Label
        </button>
        <LabelEdit
          v-else
          :name="'Label ' + (labels.length + 1)"
          :color="labelColor"
          :initials="'L' + (labels.length + 1)"
          :isForPilotOnly="isForPilotOnly"
          :isInEditMode="isInEditMode"
          @created="isInNewMode = false"
        />
      </div>
      <LabelEdit
        v-else
        :name="labelName"
        :color="labelColor"
        :initials="labelInitials"
        :isForPilotOnly="isForPilotOnly"
        :isDefault="isDefault"
        :order="order"
        :isInEditMode="isInEditMode"
        :edited="edited"
        :editedIndex="editedIndex"
        @edited="handleEdited"
      />
    </div>
    <div v-show="!isInEditMode && !isInNewMode" class="text-base">
      <ul class="text-sm select-none" sortable>
        <li
          v-for="(label, index) in labels"
          :key="label.guid_text"
          :id="index"
          class="flex items-center justify-between p-3 focus:outline-none"
          :class="[index % 2 ? 'bg-gray-700' : 'bg-gray-800']"
          style="width:256px"
          sortItem
        >
          <div @click="editLabel(index)" class="w-full flex items-center cursor-pointer">
            <div
              class="flex items-center justify-center text-gray-600 w-6 h-6 min-w-6 rounded-full"
              :style="
                'background-color:' +
                  getLabelColors(label.guid_text).bg +
                  '; color:' +
                  getLabelColors(label.guid_text).font
              "
            >
              {{ label.initials }}
            </div>
            <div class="pl-2">
              {{ label.text }}
            </div>
          </div>
          <div class="flex items-center">
            <img
              class="w-4 h-4 cursor-pointer mr-4"
              src="../../assets/icons/arrowRight.svg"
              alt="Modifier le label"
              @click="editLabel(index)"
            />
            <img class="w-4 h-4 cursor-pointer" src="../../assets/icons/hamburger.svg" alt="Déplacer" />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions, mapGetters } from "vuex"
import LabelEdit from "./LabelEdit"
import { Sortable } from "@shopify/draggable/lib/es5/draggable.bundle.legacy"

export default {
  props: {
    edited: Boolean,
  },
  data() {
    return {
      labelGuid: null,
      labelName: null,
      labelColor: null,
      labelInitials: null,
      isForPilotOnly: false,
      isDefault: false,
      order: null,
      isInEditMode: false,
      editedIndex: null,
      sortable: null,
      isInNewMode: false,
    }
  },
  computed: {
    ...mapGetters("labels", ["getLabelColors"]),
    ...mapState({
      activeLabelsMenus: (state) => state.labels.options.activeLabelsMenus,
      pastelColorsIsActive: (state) => state.labels.options.pastelColorsIsActive,
      pastelColors: (state) => state.labels.options.pastelColors,
      labels: (state) => state.labels.all,
    }),
  },
  components: {
    LabelEdit,
  },
  methods: {
    ...mapActions("labels", ["setLabelsOrder"]),
    ...mapMutations("labels", ["toggleActiveLabelsMenus"]),
    handleEdited() {
      this.labelGuid = null
      this.labelName = null
      this.labelColor = null
      this.labelInitials = null
      this.isForPilotOnly = false
      this.isDefault = false
      this.order = null
      this.isInEditMode = false
      this.editedIndex = null
      this.$emit("edited")
    },
    editLabel(index) {
      this.labelGuid = this.labels[index].guid_text
      this.labelName = this.labels[index].text
      this.labelColor = this.getLabelColors(this.labels[index].guid_text).id
      this.labelInitials = this.labels[index].initials
      this.isForPilotOnly = this.labels[index].is_for_pilot_only
      this.isDefault = this.labels[index].is_default
      this.order = this.labels[index].order
      this.isInEditMode = true
      this.editedIndex = index
      this.$emit("isInEditMode")
    },
    createSortable() {
      this.sortable = new Sortable(document.querySelector("[sortable]"), {
        draggable: "[sortItem]",
        delay: 200,
      })

      this.sortable.on("sortable:stop", () => {
        let htmlLabels = this.sortable.getDraggableElementsForContainer(document.querySelector("[sortable]"))
        this.setLabelsOrder(htmlLabels)
      })
    },
  },
  mounted() {
    this.createSortable()
  },
}
</script>

<style></style>
